export const BASE_URL = "https://jwt-auth-webdev-simplified.onrender.com";
// export const BASE_URL = "http://localhost:3001";

// use http://localhost:3001 for local testing
// https://jwt-auth-webdev-simplified.onrender.com for production
